export default {
  name: "Dashboard",
}
